"use strict";

// polyfills for old browsers
import "setimmediate";
import "event-target-polyfill";
import "url-search-params-polyfill";
import "promise-polyfill/src/polyfill";
import "yet-another-abortcontroller-polyfill";
import "whatwg-fetch";

// our app
import { init, load } from "./app.js";
import { route, router } from "./router.js";
import { login, logout } from "./login.js";
import { leaderboard } from "./leaderboard.js";
import { podcast } from "./podcast.js";
import { videos } from "./video-player.js";
import { signup } from "./signup.js";
import { home } from "./home.js";
import { passwordreset } from "./password-reset.js";
import { settings } from "./settings.js";
import { initSpinner } from "./fullscreenSpinner.js";

// routes for the app
route("/login/", login);
route("/logout/", logout);
route("/leaderboard/", leaderboard);
route("/videos/", videos);
route("pathways", videos);
route("/podcast/", podcast);
route("/registration/", signup);
route("/password-reset/", passwordreset);
route("/account-settings/", settings);
route("/", home);

// initialize app and start the router
function initApp() {
  init();
  load();
  router();
  initSpinner();
}

// start the app after DOM is ready
if (document.readyState === "complete") {
  initApp();
} else {
  window.addEventListener("DOMContentLoaded", initApp);
}

window.addEventListener("load", load);
